const getters = {
  num: (state) => state.num,
  childnum: (state) => state.childnum,
  childnum1: (state) => state.childnum1,
  themeItem: (state) => state.themeItem,
  themeList: (state) => state.themeList,
};
export default getters;
